var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#4157A1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8731 9.46771C18.896 5.61005 14.9818 3 10.5 3C6.01817 3 2.1029 5.61188 0.126855 9.46807C0.0434538 9.63305 0 9.81532 0 10.0002C0 10.185 0.0434538 10.3673 0.126855 10.5323C2.10399 14.3899 6.01817 17 10.5 17C14.9818 17 18.8971 14.3881 20.8731 10.5319C20.9565 10.3669 21 10.1847 21 9.99982C21 9.81496 20.9565 9.63269 20.8731 9.46771ZM10.5 15.25C9.46165 15.25 8.44661 14.9421 7.58325 14.3652C6.71989 13.7883 6.04698 12.9684 5.64962 12.0091C5.25226 11.0498 5.14829 9.99418 5.35087 8.97578C5.55344 7.95738 6.05345 7.02191 6.78768 6.28769C7.52191 5.55346 8.45737 5.05345 9.47577 4.85088C10.4942 4.6483 11.5498 4.75227 12.5091 5.14963C13.4684 5.54699 14.2883 6.2199 14.8652 7.08326C15.4421 7.94661 15.75 8.96165 15.75 10C15.7503 10.6895 15.6148 11.3724 15.3511 12.0095C15.0873 12.6466 14.7006 13.2255 14.2131 13.7131C13.7255 14.2006 13.1466 14.5873 12.5095 14.8511C11.8724 15.1148 11.1895 15.2503 10.5 15.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.83498C13.5 11.4918 12.1569 12.835 10.5 12.835C8.84315 12.835 7.5 11.4918 7.5 9.83498C7.5 8.17813 8.84315 6.83498 10.5 6.83498C12.1569 6.83498 13.5 8.17813 13.5 9.83498Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7f2e54ddf840d105937fe67232fe3dea.svg";
export { ForwardRef as ReactComponent };